<template>
  <nav :class="$style.container">
    <router-link v-tippy="{placement: 'bottom'}" title="Home" to="/"><font-awesome-icon :icon="faHome" /></router-link>
    <router-link v-tippy="{placement: 'bottom'}" title="Contacts" to="/contacts" v-if="hasDialer"><font-awesome-icon :icon="faPhone" /></router-link>
    <router-link v-tippy="{placement: 'bottom'}" title="Messages" to="/messages" v-if="hasSms"><font-awesome-icon :icon="faComments" /></router-link>
    <router-link v-tippy="{placement: 'bottom'}" title="Meetings" to="/meetings"><font-awesome-icon :icon="faVideo" /></router-link>
    <InstantInviteModalTrigger v-slot="{ showModal }" :class="$style.instantInviteModalTrigger">
      <button @click="showModal" v-tippy="{placement: 'bottom'}" title="Invite Notetaker">
        <font-awesome-layers>
          <font-awesome-icon :icon="faFile" />
          <font-awesome-layers-text transform="down-2 shrink-8" value="N" style="font-weight: bold" />
          <font-awesome-icon :icon="faPlus" :class="$style.plusIcon" />
        </font-awesome-layers>
      </button>
    </InstantInviteModalTrigger>
    <router-link v-tippy="{placement: 'bottom'}" title="Live Coach" to="/live-coach" v-if="hasDialer || hasLiveStreaming"><font-awesome-icon :icon="faBolt" /></router-link>
  </nav>
</template>

<script>
  import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
  import { faHome } from '@fortawesome/pro-light-svg-icons/faHome'
  import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone'
  import { faComments } from '@fortawesome/pro-light-svg-icons/faComments'
  import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo'
  import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt'
  import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
  import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
  import store from '@/lib/store'
  import InstantInviteModalTrigger from '@/components/shared/InstantInvite/InstantInviteModalTrigger'

  export default {
    components: {
      FontAwesomeIcon,
      FontAwesomeLayers,
      FontAwesomeLayersText,
      InstantInviteModalTrigger
    },
    data () {
      return {
        faHome,
        faPhone,
        faComments,
        faVideo,
        faBolt,
        faFile,
        faPlus,
        team: store.get('team')
      }
    },
    computed: {
      hasDialer () {
        return this.team.features.some((feature) => feature.name === 'DIALER')
      },
      hasSms () {
        return this.team.features.some((feature) => feature.name === 'SMS')
      },
      hasLiveStreaming () {
        return this.team.features.some((feature) => feature.name === 'VIDEOCOACH')
      }
    }
  }
</script>

<style module lang="less" src="./header-bottom.less"></style>



// WEBPACK FOOTER //
// header-bottom.vue?0f1a56a4